import DSCircularProgress from '../../../../design-system/DSCircularProgress';
import { ReactComponent as EyeIcon } from '../../../../design-system/Icons/EyeIcon.svg';
import DSSecondaryButton from '../../../../design-system/DSSecondaryButton';
import DSTooltip from '../../../../design-system/DSTooltip';

interface PreviewButtonProps {
  onClick: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  tooltip?: string;
}

// Captioned so it isn't mistaken for the "Send to Clock" button next to it,
// which carries the same eye icon. This one opens the Shopify product page.
const PreviewButton = ({
  onClick,
  disabled = false,
  isLoading = false,
  tooltip = '',
}: PreviewButtonProps) => {
  return (
    <DSTooltip title={tooltip} placement="bottom">
      {/* A disabled MUI button fires no pointer events, so the tooltip needs a
          wrapper to attach to — the disabled state is exactly when the reason
          matters most. */}
      <span style={{ display: 'inline-flex' }}>
        <DSSecondaryButton
          size="medium"
          startIcon={isLoading ? <DSCircularProgress size={16} /> : <EyeIcon />}
          onClick={onClick}
          disabled={disabled}
          sx={{ flexShrink: 0, whiteSpace: 'nowrap' }}
        >
          Product Page
        </DSSecondaryButton>
      </span>
    </DSTooltip>
  );
};

export default PreviewButton;
